(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7971],{

/***/ 8136:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/promotion",
      function () {
        return __webpack_require__(5180);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _accordion_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74905);

//기존 accordion를 사용하려다가 props 에러 발생해서 index 추가 후 사용함.



var Accordion2 = function(props) {
    var data = props.data, open = props.open, index = props.index; // index prop 추가
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), activeTab = ref[0], setActiveTab = ref[1];
    var handleActive = function(index) {
        // index 매개변수 추가
        setActiveTab(function(prev) {
            return !prev;
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (open !== undefined) {
            setActiveTab(open);
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_accordion_styles__WEBPACK_IMPORTED_MODULE_2__/* .AccordionBox */ .Rk, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_accordion_styles__WEBPACK_IMPORTED_MODULE_2__/* .AccordionHeader */ ._m, {
                    onClick: function() {
                        return handleActive(index);
                    },
                    active: activeTab,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_accordion_styles__WEBPACK_IMPORTED_MODULE_2__/* .AccordionTitle */ .il, {
                            children: data === null || data === void 0 ? void 0 : data.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: activeTab ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "fi-rs-angle-up"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "fi-rs-angle-down"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_accordion_styles__WEBPACK_IMPORTED_MODULE_2__/* .AccordionBody */ .X1, {
                    active: activeTab,
                    children: data === null || data === void 0 ? void 0 : data.content
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion2);


/***/ }),

/***/ 74547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_daum_postcode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60007);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: ",
        ";\n  z-index: 100000008;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .modal-section {\n    min-width: 40%;\n    background-color: white;\n    border-radius: 20px;\n    overflow: hidden;\n    @media (max-width: 991px) {\n      width: 60%;\n      overflow: auto;\n    }\n    @media (max-width: 767px) {\n      width: 90%;\n      overflow: auto;\n    }\n  }\n\n  .modal-content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PostCodeModal = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-44e38a55-0"
})(_templateObject(), function(props) {
    return props.isCheckout ? "" : "rgba(0, 0, 0, 0.8)";
});
var PostCode = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PostCodeModal, {
            onClick: props === null || props === void 0 ? void 0 : props.onClickHandleModal,
            isCheckout: props.isCheckout,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "modal-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "modal-content",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_daum_postcode__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                        style: {
                            height: "470px"
                        },
                        onComplete: props === null || props === void 0 ? void 0 : props.onCompletePostCode
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostCode);


/***/ }),

/***/ 5180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ promotion; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./api/apis.js
var apis = __webpack_require__(66887);
// EXTERNAL MODULE: ./api/checkSiteConfig.js
var checkSiteConfig = __webpack_require__(81197);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
// EXTERNAL MODULE: ./components/group-event/GroupEvent.styles.js
var GroupEvent_styles = __webpack_require__(11282);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./common/validation.js
var validation = __webpack_require__(10103);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./common/CustomFileInput.js
var CustomFileInput = __webpack_require__(62645);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/input/floatingInput.js
var floatingInput = __webpack_require__(44025);
// EXTERNAL MODULE: ./components/group-event/types/typeOne.styles.js
var typeOne_styles = __webpack_require__(88911);
// EXTERNAL MODULE: ./common/accordion/accordion2.js
var accordion2 = __webpack_require__(517);
;// CONCATENATED MODULE: ./components/group-event/types/typeFour.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var TypeFour = function(param) {
    var userInfoList = param.userInfoList, inputData = param.inputData, setInputData = param.setInputData, handleInputData = param.handleInputData, onClickHandleModal = param.onClickHandleModal;
    var ref12;
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), register = ref1.register, errors = ref1.formState.errors, setValue = ref1.setValue, getValues = ref1.getValues, reset = ref1.reset, trigger = ref1.trigger;
    var ref2 = (0,react.useState)([]), activeTab = ref2[0], setActiveTab = ref2[1];
    var fileRef = (0,react.useRef)();
    var accordionData = [
        {
            title: "\uBB38\uC758 \uB0B4\uC6A9",
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-group mb-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", _objectSpread({
                            placeholder: "\uBB38\uC758\uB0B4\uC6A9",
                            className: "mt-3",
                            name: "memo",
                            value: (inputData === null || inputData === void 0 ? void 0 : inputData.memo) || ""
                        }, register("memo", {
                            value: inputData === null || inputData === void 0 ? void 0 : inputData.memo,
                            onChange: function(e) {
                                return handleInputData(e, "memo");
                            }
                        }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex flex-column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-flex align-items-center justify-content-between mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        className: "",
                                        children: "\uD30C\uC77C \uC5C5\uB85C\uB4DC"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: fileRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFileInput/* default */.Z, {
                                        handleFiles: function(files) {
                                            setInputData(_objectSpread({}, inputData, {
                                                file: files[0]
                                            }));
                                        },
                                        reset: function(files) {
                                            return reset(_objectSpread({}, getValues(), {
                                                file: files[0]
                                            }));
                                        },
                                        error: errors === null || errors === void 0 ? void 0 : errors.file,
                                        name: "files",
                                        max: 1
                                    })
                                }),
                                (errors === null || errors === void 0 ? void 0 : errors.file) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mt-1 text-danger",
                                    children: errors === null || errors === void 0 ? void 0 : errors.file.message
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-3 d-flex flex-column",
                            children: (errors === null || errors === void 0 ? void 0 : errors.editYn) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mt-1 text-danger",
                                children: errors === null || errors === void 0 ? void 0 : errors.editYn.message
                            })
                        })
                    ]
                })
            })
        },
        {
            title: "\uC8FC\uBB38\uC790 \uC815\uBCF4",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                        placeholder: "\uC5C5\uCCB4\uBA85",
                        name: "company",
                        register: function(name) {
                            return _objectSpread({}, register(name, {
                                value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                onChange: function(e) {
                                    return handleInputData(e, name);
                                }
                            }));
                        },
                        value: (inputData === null || inputData === void 0 ? void 0 : inputData.company) || "",
                        error: errors === null || errors === void 0 ? void 0 : errors.company
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                        placeholder: "\uB2F4\uB2F9\uC790",
                        name: "name",
                        register: function(name) {
                            return _objectSpread({}, register(name, {
                                value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                onChange: function(e) {
                                    return handleInputData(e, name);
                                }
                            }));
                        },
                        value: (inputData === null || inputData === void 0 ? void 0 : inputData.name) || "",
                        error: errors === null || errors === void 0 ? void 0 : errors.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                        placeholder: "\uC5F0\uB77D\uCC98",
                        name: "phone",
                        register: function(name) {
                            return _objectSpread({}, register(name, {
                                value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                onChange: function(e) {
                                    return handleInputData(e, name);
                                }
                            }));
                        },
                        value: (inputData === null || inputData === void 0 ? void 0 : inputData.phone) || "",
                        error: errors === null || errors === void 0 ? void 0 : errors.phone
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                        placeholder: "\uC774\uBA54\uC77C",
                        name: "email",
                        register: function(name) {
                            return _objectSpread({}, register(name, {
                                value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                onChange: function(e) {
                                    return handleInputData(e, name);
                                }
                            }));
                        },
                        value: (inputData === null || inputData === void 0 ? void 0 : inputData.email) || "",
                        error: errors === null || errors === void 0 ? void 0 : errors.email
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-fles flex-column mb-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "custome-checkbox d-flex align-items-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                                        type: "checkbox",
                                        id: "checkBox0",
                                        className: "form-check-input",
                                        style: {
                                            paddingTop: "2px"
                                        },
                                        checked: (inputData === null || inputData === void 0 ? void 0 : inputData.check) || ""
                                    }, register("check", {
                                        onChange: function(e) {
                                            return handleInputData(e, "check");
                                        }
                                    }))),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "form-check-label",
                                        htmlFor: "checkBox0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "checkBox0",
                                        children: "(\uB3D9\uC758 \uD544\uC218) \uC81C\uCD9C\uD558\uC2E0 \uC815\uBCF4\uB85C \uC2E0\uCCAD\uC790\uAED8 \uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uC18C\uC2DD\uC744 \uBCF4\uB0B4\uB4DC\uB9BD\uB2C8\uB2E4."
                                    })
                                ]
                            }),
                            (errors === null || errors === void 0 ? void 0 : errors.check) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-danger mt-1",
                                children: (ref12 = errors.check) === null || ref12 === void 0 ? void 0 : ref12.message
                            })
                        ]
                    })
                ]
            })
        },
        {
            title: "\uBC30\uC1A1\uC9C0 \uC815\uBCF4",
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "form-group mb-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                            placeholder: "\uC8FC\uC18C",
                            name: "doro_addr",
                            register: function(name) {
                                return _objectSpread({}, register(name, {
                                    value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                    onChange: function(e) {
                                        return handleInputData(e, name);
                                    }
                                }));
                            },
                            value: (inputData === null || inputData === void 0 ? void 0 : inputData.doro_addr) || (inputData === null || inputData === void 0 ? void 0 : inputData.base_addr) || "",
                            readOnly: true,
                            onClick: onClickHandleModal,
                            error: errors === null || errors === void 0 ? void 0 : errors.doro_addr
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(floatingInput/* default */.Z, {
                            placeholder: "\uC0C1\uC138 \uC8FC\uC18C",
                            name: "detail_addr",
                            value: (inputData === null || inputData === void 0 ? void 0 : inputData.detail_addr) || "",
                            register: function(name) {
                                return _objectSpread({}, register(name, {
                                    value: inputData === null || inputData === void 0 ? void 0 : inputData[name],
                                    onChange: function(e) {
                                        return handleInputData(e, name);
                                    }
                                }));
                            },
                            error: errors === null || errors === void 0 ? void 0 : errors.detail_addr
                        })
                    ]
                })
            })
        }, 
    ];
    // inputData가 변경될 때마다 form 값 동기화
    (0,react.useEffect)(function() {
        // 주소 값이 있을 때만 form에 설정
        if ((inputData === null || inputData === void 0 ? void 0 : inputData.doro_addr) || (inputData === null || inputData === void 0 ? void 0 : inputData.base_addr)) {
            setValue("doro_addr", (inputData === null || inputData === void 0 ? void 0 : inputData.doro_addr) || (inputData === null || inputData === void 0 ? void 0 : inputData.base_addr));
        }
        if (inputData === null || inputData === void 0 ? void 0 : inputData.detail_addr) {
            setValue("detail_addr", inputData === null || inputData === void 0 ? void 0 : inputData.detail_addr);
        }
    }, [
        inputData,
        setValue
    ]);
    (0,react.useEffect)(function() {
        if (userInfoList) {
            var ref, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
            var updatedData = {
                base_addr: ((ref = userInfoList.Address) === null || ref === void 0 ? void 0 : (ref3 = ref.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.base_addr) || "",
                detail_addr: ((ref5 = userInfoList.Address) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.detail_addr) || "",
                company: ((ref8 = userInfoList.Company) === null || ref8 === void 0 ? void 0 : ref8.ReturnCode) === "9999" ? "" : inputData.company,
                email: ((ref9 = userInfoList.Member) === null || ref9 === void 0 ? void 0 : ref9.email) || "",
                name: ((ref10 = userInfoList.Member) === null || ref10 === void 0 ? void 0 : ref10.name) || "",
                phone: ((ref11 = userInfoList.Member) === null || ref11 === void 0 ? void 0 : ref11.phone) || ""
            };
            setInputData(function(prev) {
                return _objectSpread({}, prev, updatedData);
            });
            // form 값 업데이트 및 에러 초기화
            reset(updatedData);
        }
    }, [
        userInfoList,
        reset
    ]);
    //에러 관련해서 scroll
    (0,react.useEffect)(function() {
        if (Object.keys(errors).length > 0) {
            var tempArr = new Array(accordionData.length).fill(true);
            setActiveTab(tempArr);
            if (Object.keys(errors).length === 1 && errors.file) {
                stickyBodyRef.current.scrollTo({
                    behavior: "instant",
                    left: 0,
                    top: fileRef.current.offsetTop - 130
                });
            }
        }
    }, [
        errors
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typeOne_styles/* TypeOneSection */.h, {
            children: (accordionData === null || accordionData === void 0 ? void 0 : accordionData.length) > 0 && accordionData.map(function(el, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion2/* default */.Z, {
                    data: el,
                    open: activeTab[i]
                }, i);
            })
        })
    });
};
/* harmony default export */ var typeFour = (TypeFour);

// EXTERNAL MODULE: ./common/postcode.js
var postcode = __webpack_require__(74547);
// EXTERNAL MODULE: ./api/getUserInfo.js + 1 modules
var getUserInfo = __webpack_require__(48934);
// EXTERNAL MODULE: ./components/cart/cart-styles.js
var cart_styles = __webpack_require__(67503);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./common/queryKeys.js
var queryKeys = __webpack_require__(51586);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
;// CONCATENATED MODULE: ./pages/customizing/promotion/index.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function promotion_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function promotion_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            promotion_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




















var PromotionPage = function() {
    var router = (0,next_router.useRouter)();
    var ref7 = (0,react.useState)(false), isActive = ref7[0], setIsActive = ref7[1]; //활성화
    var ref1 = (0,getUserInfo/* useGetUserInfo */.Jh)(), userInfoList = ref1.data, userInfoLoading = ref1.isLoading;
    // siteConfig 조회
    var ref2 = (0,useQuery/* useQuery */.a)({
        queryKey: queryKeys/* QUERY_KEYS.SITE_CONFING.INDEX */.U.SITE_CONFING.INDEX,
        queryFn: _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "Config",
                            division: "store",
                            channel: sessionStorage.getItem("channelName") === "\uBC14\uB85C\uACE0" ? "BAROGO" : ""
                        };
                        _ctx.next = 3;
                        return (0,checkSiteConfig/* default */.Z)(body);
                    case 3:
                        res = _ctx.sent;
                        if (!((res === null || res === void 0 ? void 0 : res.Code) === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        ;
                        if ((ref = res.Data.channel) === null || ref === void 0 ? void 0 : ref.token) {
                            sessionStorage.setItem("channel", res.Data.channel.token);
                            sessionStorage.setItem("channelName", res.Data.channel.company);
                        }
                        return _ctx.abrupt("return", res.Data);
                    case 8:
                        throw new Error("\uC0AC\uC774\uD2B8 \uC124\uC815 \uC870\uD68C \uC2E4\uD328");
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    }), siteConfig = ref2.data;
    var promotionCode = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.Promotion;
    // 상세 데이터 조회 쿼리
    var ref3 = (0,useQuery/* useQuery */.a)({
        queryKey: promotionCode ? queryKeys/* QUERY_KEYS.CUSTOMIZING.PROMOTION.DETAIL */.U.CUSTOMIZING.PROMOTION.DETAIL(promotionCode) : [],
        queryFn: _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, body, res, ref8, ref9, ref10, ref11;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (promotionCode) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", null);
                    case 3:
                        body = {
                            modes: "ViewSet",
                            code: promotionCode
                        };
                        _ctx.next = 6;
                        return (0,apis/* EventPagesAPI */.SM)(body);
                    case 6:
                        res = _ctx.sent;
                        if (!((res === null || res === void 0 ? void 0 : res.Code) === "0000")) {
                            _ctx.next = 11;
                            break;
                        }
                        ;
                        setIsActive(((ref8 = res.Data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.Row) === null || ref9 === void 0 ? void 0 : ref9.useYn) !== null);
                        return _ctx.abrupt("return", promotion_objectSpread({}, (ref10 = res.Data) === null || ref10 === void 0 ? void 0 : ref10.Row, {
                            info: res === null || res === void 0 ? void 0 : (ref11 = res.Data) === null || ref11 === void 0 ? void 0 : ref11.Info
                        }));
                    case 11:
                        throw new Error(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uC870\uD68C \uC2E4\uD328");
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        enabled: !!promotionCode,
        staleTime: 0,
        refetchOnMount: false,
        onError: function(error) {
            (0,common_alert/* failAlert */.qh)(error.message);
        }
    }), detailData = ref3.data, detailDataLoading = ref3.isLoading, refetchDetailData = ref3.refetch;
    (0,react.useEffect)(function() {
        if (siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.Promotion) {
            refetchDetailData();
        }
    }, [
        siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.Promotion
    ]);
    // form
    var typeFourOptions = {
        resolver: (0,yup/* yupResolver */.X)(validation/* GPTypeFourSchema */.Ly),
        mode: "onChange"
    };
    var methods = (0,index_esm/* useForm */.cI)(typeFourOptions);
    var handleSubmit = methods.handleSubmit;
    var ref4 = (0,react.useState)({
        check: false
    }), inputData = ref4[0], setInputData = ref4[1];
    var ref5 = (0,react.useState)(false), postCodeOpen = ref5[0], setPostCodeOpen = ref5[1];
    var ref6 = (0,react.useState)(false), isFormLoading = ref6[0], setIsFormLoading = ref6[1];
    var handleInputData = function(e, key) {
        if (key === "check") {
            setInputData(promotion_objectSpread({}, inputData, promotion_defineProperty({}, key, e.target.checked)));
            return;
        }
        setInputData(promotion_objectSpread({}, inputData, promotion_defineProperty({}, key, e.target.value)));
    };
    // 우편번호 검색
    var onClickHandleModal = function() {
        setPostCodeOpen(function(prev) {
            return !prev;
        });
    };
    var onCompletePostCode = function(postcode) {
        setInputData(promotion_objectSpread({}, inputData, {
            doro_addr: postcode.roadAddress !== "" ? postcode.roadAddress : postcode.autoRoadAddress
        }));
        setPostCodeOpen(false);
    };
    // 문의 등록
    var onSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(data) {
            var body, res, ref, ref12;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsFormLoading(true);
                        _ctx.prev = 1;
                        body = promotion_objectSpread({
                            modes: "InsertSet",
                            code: siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.Promotion
                        }, data);
                        _ctx.next = 5;
                        return (0,apis/* EventPagesAPI */.SM)(body);
                    case 5:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            (0,common_alert/* successAlert */.Cq)(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uB4F1\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            methods.reset(); //form 초기화
                            setInputData({
                                check: false
                            }); //inputdata 초기화
                            refetch(); //유저 정보 재조회
                            router.reload(); // 새로고침
                        } else if (res.Code === "8888") {} else {
                            ;
                            (0,common_alert/* failAlert */.qh)(((ref12 = res.Data) === null || ref12 === void 0 ? void 0 : ref12.Msg) || "\uB4F1\uB85D \uC2E4\uD328\uC785\uB2C8\uB2E4.");
                        }
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,common_alert/* failAlert */.qh)("\uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.");
                    case 12:
                        _ctx.prev = 12;
                        setIsFormLoading(false);
                        return _ctx.finish(12);
                    case 15:
                        methods.reset();
                        setInputData({
                            check: false
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9,
                    12,
                    15
                ]
            ]);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
            parent: "\uD648",
            sub: "\uB9DE\uCDA4\uC81C\uC791",
            subChild: "\uD310\uCD09\uBB3C\uC81C\uC791",
            pageTitle: SeoMeta/* SeoMeta.promotionalItemCreation.title */.e.promotionalItemCreation.title,
            pageDesc: SeoMeta/* SeoMeta.promotionalItemCreation.description */.e.promotionalItemCreation.description,
            pageKeyword: SeoMeta/* SeoMeta.promotionalItemCreation.keywords */.e.promotionalItemCreation.keywords,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupEvent_styles/* Container */.W2, {
                    className: "container",
                    children: !isActive ? // {/* 데이터 x */}
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* EmptyWrapper */.zD, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "https://image.caretbio.com/store/webhard/\u110C\u1175\u110F\u1161\u11AF\u1105\u1166\u11BA_\u1110\u1161\u11AB\u1109\u1169_420x200.png",
                                alt: "empty-edu"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "title",
                                children: "\uD604\uC7AC \uBB38\uC758\uAC00\uB2A5\uD55C \uD310\uCD09\uBB3C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/esg-guide/letter",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "btn",
                                        children: "ESG \uB274\uC2A4\uB808\uD130 \uBCF4\uB7EC\uAC00\uAE30"
                                    })
                                })
                            })
                        ]
                    }) : //  {/* 데이터 o */}
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* DetailWrapper */.c0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* DetailSection */.Kk, {
                                className: "single-content",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: detailData === null || detailData === void 0 ? void 0 : detailData.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: detailData === null || detailData === void 0 ? void 0 : detailData.content
                                        },
                                        className: "ck-content"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, promotion_objectSpread({}, methods, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GroupEvent_styles/* StickySection */.hI, {
                                    onSubmit: handleSubmit(onSubmit),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "mb-3",
                                            children: "\uD310\uCD09\uBB3C\uC81C\uC791 \uC2E0\uCCAD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupEvent_styles/* StickyBody */.ed, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typeFour, {
                                                userInfoList: userInfoList === null || userInfoList === void 0 ? void 0 : userInfoList.Data,
                                                inputData: inputData,
                                                setInputData: setInputData,
                                                handleInputData: handleInputData,
                                                onClickHandleModal: onClickHandleModal
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupEvent_styles/* StickyFooter */.oW, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "submit",
                                                className: "btn confirm",
                                                children: "\uBB38\uC758\uD558\uAE30"
                                            })
                                        })
                                    ]
                                })
                            }))
                        ]
                    })
                }),
                postCodeOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(postcode/* default */.Z, {
                    onClickHandleModal: onClickHandleModal,
                    onCompletePostCode: onCompletePostCode
                })
            ]
        })
    });
};
/* harmony default export */ var promotion = (PromotionPage);


/***/ }),

/***/ 90651:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
function _typeof(a){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},_typeof(a)}Object.defineProperty(exports, "__esModule", ({value:!0})),exports["default"]=void 0;var _react=_interopRequireWildcard(__webpack_require__(67294)),_loadPostcode=_interopRequireWildcard(__webpack_require__(52171)),_excluded=["scriptUrl","className","style","defaultQuery","autoClose","errorMessage","onComplete","onClose","onResize","onSearch"];function _getRequireWildcardCache(a){if("function"!=typeof WeakMap)return null;var b=new WeakMap,c=new WeakMap;return(_getRequireWildcardCache=function(a){return a?c:b})(a)}function _interopRequireWildcard(a,b){if(!b&&a&&a.__esModule)return a;if(null===a||"object"!==_typeof(a)&&"function"!=typeof a)return{default:a};var c=_getRequireWildcardCache(b);if(c&&c.has(a))return c.get(a);var d={},e=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var f in a)if("default"!=f&&Object.prototype.hasOwnProperty.call(a,f)){var g=e?Object.getOwnPropertyDescriptor(a,f):null;g&&(g.get||g.set)?Object.defineProperty(d,f,g):d[f]=a[f]}return d.default=a,c&&c.set(a,d),d}function ownKeys(a,b){var c=Object.keys(a);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(a);b&&(d=d.filter(function(b){return Object.getOwnPropertyDescriptor(a,b).enumerable})),c.push.apply(c,d)}return c}function _objectSpread(a){for(var b,c=1;c<arguments.length;c++)b=null==arguments[c]?{}:arguments[c],c%2?ownKeys(Object(b),!0).forEach(function(c){_defineProperty(a,c,b[c])}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(b)):ownKeys(Object(b)).forEach(function(c){Object.defineProperty(a,c,Object.getOwnPropertyDescriptor(b,c))});return a}function _objectWithoutProperties(a,b){if(null==a)return{};var c,d,e=_objectWithoutPropertiesLoose(a,b);if(Object.getOwnPropertySymbols){var f=Object.getOwnPropertySymbols(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||Object.prototype.propertyIsEnumerable.call(a,c)&&(e[c]=a[c])}return e}function _objectWithoutPropertiesLoose(a,b){if(null==a)return{};var c,d,e={},f=Object.keys(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||(e[c]=a[c]);return e}function _classCallCheck(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function _defineProperties(a,b){for(var c,d=0;d<b.length;d++)c=b[d],c.enumerable=c.enumerable||!1,c.configurable=!0,"value"in c&&(c.writable=!0),Object.defineProperty(a,c.key,c)}function _createClass(a,b,c){return b&&_defineProperties(a.prototype,b),c&&_defineProperties(a,c),a}function _inherits(a,b){if("function"!=typeof b&&null!==b)throw new TypeError("Super expression must either be null or a function");a.prototype=Object.create(b&&b.prototype,{constructor:{value:a,writable:!0,configurable:!0}}),b&&_setPrototypeOf(a,b)}function _setPrototypeOf(a,b){return _setPrototypeOf=Object.setPrototypeOf||function(a,b){return a.__proto__=b,a},_setPrototypeOf(a,b)}function _createSuper(a){var b=_isNativeReflectConstruct();return function(){var c,d=_getPrototypeOf(a);if(b){var e=_getPrototypeOf(this).constructor;c=Reflect.construct(d,arguments,e)}else c=d.apply(this,arguments);return _possibleConstructorReturn(this,c)}}function _possibleConstructorReturn(a,b){return b&&("object"===_typeof(b)||"function"==typeof b)?b:_assertThisInitialized(a)}function _assertThisInitialized(a){if(void 0===a)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return a}function _isNativeReflectConstruct(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(a){return!1}}function _getPrototypeOf(a){return _getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function(a){return a.__proto__||Object.getPrototypeOf(a)},_getPrototypeOf(a)}function _defineProperty(a,b,c){return b in a?Object.defineProperty(a,b,{value:c,enumerable:!0,configurable:!0,writable:!0}):a[b]=c,a}var defaultErrorMessage=/*#__PURE__*/_react.default.createElement("p",null,"\uD604\uC7AC Daum \uC6B0\uD3B8\uBC88\uD638 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694."),defaultStyle={width:"100%",height:400},defaultProps={scriptUrl:_loadPostcode.postcodeScriptUrl,errorMessage:defaultErrorMessage,autoClose:!0},DaumPostcodeEmbed=/*#__PURE__*/function(a){function b(){var a;_classCallCheck(this,b);for(var d=arguments.length,e=Array(d),f=0;f<d;f++)e[f]=arguments[f];return a=c.call.apply(c,[this].concat(e)),_defineProperty(_assertThisInitialized(a),"mounted",!1),_defineProperty(_assertThisInitialized(a),"wrap",/*#__PURE__*/(0,_react.createRef)()),_defineProperty(_assertThisInitialized(a),"state",{hasError:!1}),_defineProperty(_assertThisInitialized(a),"initiate",function(b){if(a.wrap.current){var c=a.props,d=c.scriptUrl,e=c.className,f=c.style,g=c.defaultQuery,h=c.autoClose,i=c.errorMessage,j=c.onComplete,k=c.onClose,l=c.onResize,m=c.onSearch,n=_objectWithoutProperties(c,_excluded),o=new b(_objectSpread(_objectSpread({},n),{},{oncomplete:function oncomplete(b){j&&j(b),h&&a.wrap.current&&a.wrap.current.remove()},onsearch:m,onresize:l,onclose:k,width:"100%",height:"100%"}));o.embed(a.wrap.current,{q:g,autoClose:h})}}),_defineProperty(_assertThisInitialized(a),"onError",function(b){console.error(b),a.setState({hasError:!0})}),a}_inherits(b,a);var c=_createSuper(b);return _createClass(b,[{key:"componentDidMount",value:function componentDidMount(){var a=this.initiate,b=this.onError,c=this.props.scriptUrl;c&&(this.mounted||((0,_loadPostcode.default)(c).then(a).catch(b),this.mounted=!0))}},{key:"render",value:function render(){var a=this.props,b=a.className,c=a.style,d=a.errorMessage,e=this.state.hasError;return/*#__PURE__*/_react.default.createElement("div",{ref:this.wrap,className:b,style:_objectSpread(_objectSpread({},defaultStyle),c)},e&&d)}}]),b}(_react.Component);_defineProperty(DaumPostcodeEmbed,"defaultProps",defaultProps);var _default=DaumPostcodeEmbed;exports["default"]=_default;

/***/ }),

/***/ 60007:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0}),__webpack_unused_export__ = ({enumerable:!0,get:function get(){return _DaumPostcodeEmbed.default}}),__webpack_unused_export__ = ({enumerable:!0,get:function get(){return _useDaumPostcodePopup.default}}),__webpack_unused_export__ = ({enumerable:!0,get:function get(){return _loadPostcode.default}}),exports.ZP=void 0;var _DaumPostcodeEmbed=_interopRequireDefault(__webpack_require__(90651)),_useDaumPostcodePopup=_interopRequireDefault(__webpack_require__(339)),_loadPostcode=_interopRequireDefault(__webpack_require__(52171));function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}var _default=_DaumPostcodeEmbed.default;exports.ZP=_default;

/***/ }),

/***/ 52171:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0})),exports["default"]=exports.postcodeScriptUrl=void 0;var postcodeScriptUrl="https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";exports.postcodeScriptUrl="https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";var loadPostcode=function(){var a=null;return function(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:postcodeScriptUrl;return a?a:(a=new Promise(function(a,c){var d=document.createElement("script");d.src=b,d.onload=function(){var b,d;return null!==(b=window)&&void 0!==b&&null!==(d=b.daum)&&void 0!==d&&d.Postcode?a(window.daum.Postcode):void c(new Error("Script is loaded successfully, but cannot find Postcode module. Check your scriptURL property."))},d.onerror=function(a){return c(a)},d.id="daum_postcode_script",document.body.appendChild(d)}),a)}}(),_default=loadPostcode;exports["default"]=_default;

/***/ }),

/***/ 339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
function _typeof(a){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},_typeof(a)}Object.defineProperty(exports, "__esModule", ({value:!0})),exports["default"]=void 0;var _react=__webpack_require__(67294),_loadPostcode=_interopRequireWildcard(__webpack_require__(52171)),_excluded=["defaultQuery","left","top","popupKey","popupTitle","autoClose","onComplete","onResize","onClose","onSearch","onError"];function _getRequireWildcardCache(a){if("function"!=typeof WeakMap)return null;var b=new WeakMap,c=new WeakMap;return(_getRequireWildcardCache=function(a){return a?c:b})(a)}function _interopRequireWildcard(a,b){if(!b&&a&&a.__esModule)return a;if(null===a||"object"!==_typeof(a)&&"function"!=typeof a)return{default:a};var c=_getRequireWildcardCache(b);if(c&&c.has(a))return c.get(a);var d={},e=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var f in a)if("default"!=f&&Object.prototype.hasOwnProperty.call(a,f)){var g=e?Object.getOwnPropertyDescriptor(a,f):null;g&&(g.get||g.set)?Object.defineProperty(d,f,g):d[f]=a[f]}return d.default=a,c&&c.set(a,d),d}function ownKeys(a,b){var c=Object.keys(a);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(a);b&&(d=d.filter(function(b){return Object.getOwnPropertyDescriptor(a,b).enumerable})),c.push.apply(c,d)}return c}function _objectSpread(a){for(var b,c=1;c<arguments.length;c++)b=null==arguments[c]?{}:arguments[c],c%2?ownKeys(Object(b),!0).forEach(function(c){_defineProperty(a,c,b[c])}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(b)):ownKeys(Object(b)).forEach(function(c){Object.defineProperty(a,c,Object.getOwnPropertyDescriptor(b,c))});return a}function _defineProperty(a,b,c){return b in a?Object.defineProperty(a,b,{value:c,enumerable:!0,configurable:!0,writable:!0}):a[b]=c,a}function _objectWithoutProperties(a,b){if(null==a)return{};var c,d,e=_objectWithoutPropertiesLoose(a,b);if(Object.getOwnPropertySymbols){var f=Object.getOwnPropertySymbols(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||Object.prototype.propertyIsEnumerable.call(a,c)&&(e[c]=a[c])}return e}function _objectWithoutPropertiesLoose(a,b){if(null==a)return{};var c,d,e={},f=Object.keys(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||(e[c]=a[c]);return e}function useDaumPostcodePopup(){var a=0<arguments.length&&arguments[0]!==void 0?arguments[0]:_loadPostcode.postcodeScriptUrl;(0,_react.useEffect)(function(){(0,_loadPostcode.default)(a)},[a]);var b=(0,_react.useCallback)(function(b){var c=_objectSpread({},b),d=c.defaultQuery,e=c.left,f=c.top,g=c.popupKey,h=c.popupTitle,i=c.autoClose,j=c.onComplete,k=c.onResize,l=c.onClose,m=c.onSearch,n=c.onError,o=_objectWithoutProperties(c,_excluded);return(0,_loadPostcode.default)(a).then(function(a){var b=new a(_objectSpread(_objectSpread({},o),{},{oncomplete:j,onsearch:m,onresize:k,onclose:l}));b.open({q:d,left:e,top:f,popupTitle:h,popupKey:g,autoClose:i})}).catch(n)},[a]);return b}var _default=useDaumPostcodePopup;exports["default"]=_default;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,4231,7533,2511,4027,7503,5582,9774,2888,179], function() { return __webpack_exec__(8136); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);